export default __webpack_public_path__ + "c156ef488c54991dee40e1459c2b2272.png";